import React, { useState } from "react"
import SharedFlatpickr from "@shared/flatpickr"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const AddHeatingPeriods = ({ heatingPeriods }) => {
  if (!heatingPeriods) return null

  const [selectedHeatingPeriods, setSelectedHeatingPeriods] = useState(
    heatingPeriods.map(hp => ({
      id: hp.id,
      startDate: hp.startDate,
      endDate: hp.endDate,
      _destroy: false
    }))
  )

  const addHeatingPeriod = e => {
    e.preventDefault()
    setSelectedHeatingPeriods([
      ...selectedHeatingPeriods,
      { id: null, startDate: "", endDate: "", _destroy: false }
    ])
  }

  const removeHeatingPeriod = (e, index) => {
    e.preventDefault()
    const updated = [...selectedHeatingPeriods]
    const heatingPeriodToRemove = updated[index]

    if (heatingPeriodToRemove.id) {
      updated[index]._destroy = true
    } else {
      updated.splice(index, 1)
    }

    setSelectedHeatingPeriods(updated)
  }

  const handleChange = (index, field, value) => {
    const updated = [...selectedHeatingPeriods]

    updated[index][field] = value

    setSelectedHeatingPeriods(updated)
  }

  return (
    <>
      <div className="cocoon-grid mb-2">
        <div className="cocoon-grid__header">
          <label>{I18n.t("meters_groups.heating_periods")}</label>
        </div>
      </div>
      <div className="d-flex align-items-center">
        <div style={{ width: "49%" }}><label>{I18n.t("meters_groups.date_switch_on")}</label></div>
        <div><label>{I18n.t("meters_groups.date_switch_off")}</label></div>
      </div>
      { selectedHeatingPeriods.map((heatingPeriod, index) => {
        return <div
        key={index}
        className={`my-1 d-flex align-items-center ${heatingPeriod._destroy ? "d-none" : ""}`}
        >
          <SharedFlatpickr
            options={{
              locale:     I18n.locale,
              dateFormat: "d/m/Y"
            }}
            name        = "startDate"
            className   = "form-control flatpickr-nobg text-center"
            placeholder = {I18n.t("meters_groups.start_date")}
            onChange    = {newVal => handleChange(index, "startDate", newVal)}
            value       = {heatingPeriod.startDate}
          />

          <SharedFlatpickr
            options={{
              locale:     I18n.locale,
              dateFormat: "d/m/Y"
            }}
            name        = "endDate"
            className   = "form-control flatpickr-nobg text-center mx-1"
            placeholder = {I18n.t("meters_groups.end_date")}
            onChange    = {newVal => handleChange(index, "endDate", newVal)}
            value       = {heatingPeriod.endDate}
          />

          <input
              type="hidden"
              name={`meters_group[heating_periods_attributes][${index}][id]`}
              value={heatingPeriod.id || ""}
            />

          <input
            type="hidden"
            name={`meters_group[heating_periods_attributes][${index}][start_date]`}
            value={heatingPeriod.startDate || ""}
          />

          <input
            type="hidden"
            name={`meters_group[heating_periods_attributes][${index}][end_date]`}
            value={heatingPeriod.endDate || ""}
          />

          <a href="#" onClick={e => removeHeatingPeriod(e, index)}>
            <FontAwesomeIcon icon="minus-circle" />
          </a>

          {heatingPeriod._destroy && (
            <input
              type="hidden"
              name={`meters_group[heating_periods_attributes][${index}][_destroy]`}
              value="true"
            />
          )}
        </div>
      })}
      <a className="small flex-end mt-2" href="#" onClick={addHeatingPeriod}>
        <FontAwesomeIcon icon="plus-circle" className="mr-1" />
        {I18n.t("meters_groups.add_heating_period")}
      </a>
    </>
  )
}

export default AddHeatingPeriods
